import { connect } from 'react-redux';
import Drawer from './drawer'

// import { logout } from './../../reducers/auth.reducers';
import { logout } from '../../reducers/auth.reducers';

const mapStateToProps = state => ({
  config: state.authentication.config,
});

const mapDispatchToProps = dispatch => ({
  onLogout: () => dispatch(logout())
});

export default connect(mapStateToProps, mapDispatchToProps)(Drawer);



// WEBPACK FOOTER //
// ./src/app/components/drawer/drawer.container.js